import { render, staticRenderFns } from "./ZG.vue?vue&type=template&id=bc841262&scoped=true&"
import script from "./ZG.vue?vue&type=script&lang=js&"
export * from "./ZG.vue?vue&type=script&lang=js&"
import style0 from "./ZG.vue?vue&type=style&index=0&id=bc841262&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc841262",
  null
  
)

export default component.exports